export { default } from './IndicationQuestion.js';
